import { marketingRouteMeta } from '#marketing/lib/marketing-route-meta.js';
import { MarketingAboutPage } from '#marketing/components/MarketingAboutPage.jsx';

/** @param {{ matches: Array<{ id?: string, pathname?: string, data?: unknown }> }} args */
export function meta({ matches }) {
  return marketingRouteMeta({ matches, page: 'about', pagePath: '/about' });
}

export default function About() {
  return <MarketingAboutPage />;
}
